import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutes } from './login.routes';
import { SharedModule } from './../../shared/shared.module';


@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    LoginRoutes,
    SharedModule
  ],
  exports: [LoginComponent]
})
export class LoginModule { }
